const myStyles = theme => ({
  style: {
    style: {
      zIndex: "1400"
    }
  }
});

export default myStyles;
